export default __webpack_public_path__ + "static/media/Belt of Swiftstriking.4263992b.jpg";